import { render } from "./HeroiconsOutlineChevronDoubleUp.vue?vue&type=template&id=693bb7af"
const script = {}

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineChevronDoubleUp.vue"]])

export default __exports__